// src/themes/cosmic-purple.ts
import { Theme } from "./types";

export const cosmicPurpleTheme: Theme = {
  "background-light": "20 15 35", // #140F23 - Deep cosmic purple
  "background-dark": "15 10 25", // #0F0A19 - Deeper space
  "card-light": "35 25 55", // #231937 - Cosmic card
  "card-dark": "30 20 45", // #1E142D - Darker cosmic
  "input-light": "50 35 75", // #32234B - Nebula input
  "input-dark": "45 30 65", // #2D1E41 - Darker nebula
  "border-light": "90 60 130", // #5A3C82 - Purple border
  "border-dark": "80 50 120", // #503278 - Deep purple
  primary: "168 85 247", // #A855F7 - Vibrant purple
  "primary-hover": "147 51 234", // #9333EA - Electric purple
  text: "230 220 255", // #E6DCFF - Soft cosmic light
  "text-dark": "220 210 245", // #DCD2F5 - Gentle glow
  "text-secondary": "180 160 220", // #B4A0DC - Muted cosmic
  "text-secondary-dark": "160 140 200", // #A08CC8 - Deep cosmic
};
